module.exports = __webpack_public_path__ + "fonts/fa-v2-regular-400.d6dfd56d.woff2";